import React from 'react' // eslint-disable-line
import styled from 'styled-components'
import { Config } from '../../../config'

const { palette } = Config

const transparentPixel =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAACklEQVQYV2P4DwABAQEAWk1v8QAAAABJRU5ErkJggg=='

export const LazyImage = ({
  width,
  height,
  onClick,
  src: source,
  srcLarge: sourceLarge,
  background,
  alt,
  backgroundOverImage,
}: LazyImageProps) => {
  const ratio = height && width ? height / width : 1

  const src = source || transparentPixel

  const handleClick = () => {
    if (onClick && typeof onClick === 'function') {
      return onClick()
    }
  }

  return (
    <ImageWrapper
      ratio={ratio}
      background={background}
      onClick={handleClick}
      backgroundOverImage={backgroundOverImage}
    >
      <CenterImage>
        <Image
          src={src}
          srcSet={sourceLarge && `${src} 1x, ${sourceLarge} 2x`}
          alt={alt}
          width={width}
          loading="lazy"
        />
      </CenterImage>
    </ImageWrapper>
  )
}

export type LazyImageProps = {
  width?: any
  height?: any
  onClick?: Function
  placeOnTop?: boolean
  src: string
  srcLarge?: string
  background?: string
  alt?: string
  backgroundOverImage?: boolean
}

export type ImageWrapperProps = {
  background?: string
  ratio: number
  backgroundOverImage?: boolean
}

// TODO: review the background color after demo
const ImageWrapper = styled.div<ImageWrapperProps>`
  position: relative;
  padding-bottom: ${(props) => props.ratio * 100}%;
  width: 100%;
  max-height: 100%;
  cursor: pointer;

  ${(props) =>
    !props.backgroundOverImage
      ? `background-color: ${
          props.background ? props.background : palette.disabled
        };`
      : `
      &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${
          props.background ? props.background : palette.primary
        };
        opacity: 0.072;
        pointer-events: none;
      }
  `}
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
`

const CenterImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
